export enum AuthorLocation {
  HongKong = "hong kong",
  NotAvailable = "not available",
}
